<div class="send-money pt-4">
    <div class="d-flex justify-content-between align-items-center mx-4 gap-2 flex-wrap">
        <div class="d-flex justify-content-between align-items-center flex-wrap send-money-date">
            <app-date-range-picker (dateChange)="onDateChange($event)"></app-date-range-picker>
            <button
                (click)="openAdvanceSearchUserPopup('sender_user')"
                [ngClass]="{ 'user-buttons-highlight': isUserFilterApplied('sender_user') }"
                class="d-flex justify-content-around align-items-center user-buttons-filter rounded-0 me-2"
            >
                <mat-icon [svgIcon]="isUserFilterApplied('sender_user') ? 'app-user-icon-light' : 'app-user-icon'" class="user-buttons-icon"></mat-icon>
                <span class="user-buttons-text">Sender</span>
                <mat-icon
                    (click)="removeAdvanceSearch('sender_user', $event)"
                    *ngIf="isUserFilterApplied('sender_user')"
                    class="user-buttons-icon-close"
                    fontIcon="close"
                ></mat-icon>
            </button>
            <button
                (click)="openAdvanceSearchUserPopup('receiver_user')"
                [ngClass]="{ 'user-buttons-highlight': isUserFilterApplied('receiver_user') }"
                class="d-flex justify-content-around align-items-center user-buttons-filter me-2"
            >
                <mat-icon [svgIcon]="isUserFilterApplied('receiver_user') ? 'app-user-icon-light' : 'app-user-icon'" class="user-buttons-icon"></mat-icon>
                <span class="user-buttons-text">Receiver</span>
                <mat-icon
                    (click)="removeAdvanceSearch('receiver_user', $event)"
                    *ngIf="isUserFilterApplied('receiver_user')"
                    class="user-buttons-icon-close"
                    fontIcon="close"
                ></mat-icon>
            </button>
        </div>
        <div class="d-flex flex-wrap flex-md-nowrap justify-content-end align-items-center gap-2 ms-auto mt-2 mt-md-0 send-money-btn-row">
            <button
                (click)="exportExcel()"
                class="btn btn-primary rounded-pill d-flex align-items-center me-1 w-100 w-md-auto"
                mat-flat-button
                [disabled]="transactions.length === 0"
            >
                <mat-icon class="me-2 fs-small" svgIcon="top-up-client"></mat-icon>
                <span>Export Data</span>
            </button>
            <button (click)="openSendMoneyModal()" class="btn btn-primary rounded-pill d-flex align-items-center w-100 w-md-auto" mat-flat-button>
                <mat-icon class="me-2 fs-small" svgIcon="top-up-client"></mat-icon>
                <span>Top-up client</span>
            </button>
            <button (click)="openCashOut()" class="btn btn-primary rounded-pill d-flex align-items-center w-100 w-md-auto" mat-flat-button>
                <mat-icon class="me-2 fs-small" svgIcon="cash-out"></mat-icon>
                <span>Cash Out for Client</span>
            </button>
        </div>
    </div>

    <app-table
        (dataLoadMore)="searchTransactions()"
        [dataColumns]="columns"
        [dataHasMoreRecords]="hasMoreRecords"
        [dataLoading]="loading"
        [dataSortableColumns]="sortableColumns"
        [dataSource]="transactions"
        class="transaction-table"
        dataAbsenceText="No transactions"
        dataName="Recent Transactions"
        (visibleColumnsChanged)="handleVisibleColumnsChange($event)"
    >
        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="transaction_timestamp" let-transaction>
            <p>{{ transaction.transaction_timestamp | date : 'dd MMM yyyy' | optionalPlaceholder }}</p>
            <span class="text-muted">{{ transaction.transaction_timestamp | date : 'hh:mm' | optionalPlaceholder }}</span>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="receiver" let-transaction>
            <div class="d-flex align-items-center">
                <!-- <img [src]="transaction.sender_info.imgUrl" alt="" class="rounded-circle" style="width: 40px; height: 40px" /> -->
                <div>
                    <div class="fw-normal">{{ transaction.receiver_user_id }}</div>
                    <!-- <div class="fw-bold fs-6">{{ transaction.receiver_user_id }}</div> -->
                    <!-- <div class="fw-normal text-muted">{{ transaction.sender_account_id }}</div> -->
                </div>
            </div>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="amount_received" let-transaction>
            <div class="d-flex align-items-center">
                <div class="wallet-currency rounded-pill p-1 d-flex align-items-center justify-content-between m-2">
                    <div class="d-flex align-items-center justify-content-between rounded-pill p-2" style="background-color: #f0f1f5">
                        <!-- <img src="../../../assets/home/united states.svg" alt="{{ transaction.sent_currency }}" /> -->
                        <img
                            [src]="'/assets/currency-flags/' + transaction.transaction_currency + '-flag.svg'"
                            [alt]="transaction.transaction_currency"
                            style="width: 12px; height: 12px"
                            class="rounded-circle"
                        />
                        <span class="ms-2" style="font-size: 11px">{{ transaction.transaction_currency }}</span>
                    </div>
                </div>
                <p class="font-size:13px">{{ transaction.transaction_amount + transaction.fee_amount | number }}</p>
            </div>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="amount_sent" let-transaction>
            <div class="d-flex align-items-center">
                <div class="wallet-currency rounded-pill p-1 d-flex align-items-center justify-content-between m-2">
                    <div class="d-flex align-items-center justify-content-between rounded-pill p-2" style="background-color: #f0f1f5">
                        <img
                            [src]="'/assets/currency-flags/' + transaction.transaction_currency + '-flag.svg'"
                            [alt]="transaction.transaction_currency"
                            style="width: 12px; height: 12px"
                            class="rounded-circle"
                        />
                        <span class="ms-2" style="font-size: 11px">{{ transaction.transaction_currency }}</span>
                    </div>
                </div>
                <p class="font-size:13px">{{ transaction.transaction_amount | number }}</p>
            </div>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="transfer_status" let-transaction>
            <p
                [class.status-badge-failed]="transaction.status_code !== '0000'"
                [class.status-badge-success]="transaction.status_code === '0000'"
                class="py-1 px-4 fw-semibold rounded-pill status-badge"
            >
                {{ transaction.status_code | transferStatus }}
            </p>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="transaction_type" let-transaction>
            <p class="text-gray">{{ transaction.transaction_type | transactionType | optionalPlaceholder }}</p>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="action">
            <button class="d-flex align-items-center rounded-pill bg-white text-black view-transaction-details">
                <span class="m-1 fw-semibold view-transaction-details-text">View Details</span>
                <mat-icon class="view-transaction-details-icon" fontIcon="chevron_right" />
            </button>
        </ng-template>

        <ng-template #transactionAbsentValue>N/A</ng-template>
    </app-table>
</div>
